import React from 'react';
import { useQuery } from 'react-query';
import { Get } from '../../../../utils/httpProvider';
import { ACCOUNT_API } from '../../../../utils/apiUrl';

/**
 * Component hiển thị thông tin cán bộ (FullName & Username) 
 * Thực hiện lấy dữ liệu từ Backend Auth (Port 5003) ngay tại Frontend.
 * Tận dụng React Query để cache dữ liệu, tránh gọi API lặp lại cho cùng 1 User.
 */
const UserInfoCell = ({ userId, mode = 'full' }) => {
    // 1. Lấy Username từ Account API (Port 5003)
    const { data: account, isLoading: loadingAccount } = useQuery(
        ['account', userId],
        () => Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, userId),
        { 
            enabled: !!userId, 
            staleTime: 600000, 
            cacheTime: 900000 
        }
    );

    // 2. Lấy Họ tên chi tiết từ AccountAuthInfo API (Port 5003)
    const { data: authInfo, isLoading: loadingAuthInfo } = useQuery(
        ['authInfo', userId],
        () => Get(ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG, userId),
        { 
            enabled: !!userId, 
            staleTime: 600000, 
            cacheTime: 900000 
        }
    );

    if (!userId) return <span className="text-muted">N/A</span>;
    
    if (loadingAccount || loadingAuthInfo) {
        return (
            <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <small className="text-muted" style={{ fontSize: '0.8rem' }}>Đang tải...</small>
            </div>
        );
    }

    const fullName = [
        authInfo?.lastName || authInfo?.LastName,
        authInfo?.middleName || authInfo?.MiddleName,
        authInfo?.firstName || authInfo?.FirstName
    ].filter(Boolean).join(' ') || account?.fullName || account?.FullName || 'Chưa cập nhật';

    const username = account?.username || account?.Username || 'N/A';

    if (mode === 'name') return <span className="font-weight-bold text-dark">{fullName}</span>;
    if (mode === 'username') return <span className="font-weight-bold text-muted">{username}</span>;

    return (
        <div>
            <div className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName}</div>
            <small className="text-muted" style={{ fontSize: '0.8rem' }}>{username}</small>
        </div>
    );
};

export default UserInfoCell;
